import AxiosInstance from '../../config/AxiosInstance';

const getLocations = async (userId: any, companyId: any, page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/location', {
            params: {
                user_id: userId,
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

const updateCurrentActive = async (payloadData: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/location/updateCurrentActive', payloadData);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateCurrentCompanyActive = async (payloadData: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/companies/updateCurrentActive', payloadData);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    getLocations,
    updateCurrentActive,
    updateCurrentCompanyActive
}